import React from 'react'

import './link.scss'

const Link = ({ data = {} }) => {
  let linkUrl = data.link

  if (data.internalLinks && data.internalLinks[0]) {
    const { slug } = data.internalLinks[0]
    linkUrl = `/${slug}`
  }

  return <div className='_link-content'>
    <a href={linkUrl} target="_blank">
      <p className="_link-content-text">{data.text}</p>
    </a>
  </div>
}

export default Link